export var defaultLanguage = {
    id: 'en',
    title: 'English',
    icon: '🇺🇸'
};
export var Languages = [
    defaultLanguage,
    {
        id: 'fr',
        title: 'French',
        icon: '🇫🇷'
    },
    {
        id: 'nl',
        title: 'Dutch',
        icon: '🇧🇪'
    }
];

//# sourceMappingURL=Languages.js.map